import { useCallback, useState } from 'react'

export const useFilterToggler = () => {
  const [filterIsActive, setFilterIsActive] = useState<boolean>(false)

  const handleFilter = useCallback((): void => {
    setFilterIsActive((prevState) => !prevState)
  }, [])

  const activeFilter = useCallback((): void => {
    setFilterIsActive(true)
  }, [])

  const closeFilter = useCallback((): void => {
    setFilterIsActive(false)
  }, [])

  return { filterIsActive, handleFilter, activeFilter, closeFilter }
}
